import * as React from "react";
import { shopConfig } from "~/helpers/shopConfig";
import styled, { css } from "~/styled";
import LegalAddress from "./LegalAddress";
import PhoneNumber from "./PhoneNumber";

const OrganizationInfoWrapper = styled.div<{ organization: string }>`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${props =>
    props.organization === "emerchant" &&
    css`
      flex-direction: column-reverse;
    `}
`;

class OrganizationInfo extends React.Component {
  public render() {
    const { organization } = shopConfig;

    return (
      <OrganizationInfoWrapper organization={organization}>
        <LegalAddress />

        <PhoneNumber />
      </OrganizationInfoWrapper>
    );
  }
}

export default OrganizationInfo;



// WEBPACK FOOTER //
// ./src/components/Legal/OrganizationInfo.tsx